import {NestToastOptions} from "./nest-toast.interfaces";
import {HTMLStencilElement} from "@stencil/core/internal";

export interface HTMLNoticeElement extends HTMLStencilElement {
  title: string;
  message: string;
  close: () => Promise<void>
}

export class NestToastController {
  private container: HTMLElement | null = null
  private preQueue: HTMLNoticeElement[] = []
  private queue: HTMLNoticeElement[] = [];
  private queueLimit: number = 6;

  tag = 'nest-toast'

  constructor() {}

  public create(options: NestToastOptions): any {
    this.setupContainer();

    const el: HTMLNoticeElement = document.createElement(this.tag) as unknown as HTMLNoticeElement;

    Object.assign(el, { data: options});

    this.preQueue.push(el);

    if (this.queue.length < this.queueLimit) {
      const el = this.preQueue.shift()
      if (el && this.container) {
        this.queue.push(el)
        this.container.insertAdjacentElement('beforeend', el)
      }
    }
    if (this.queue.length === 0) {
      this.container?.remove()
    }

    console.log('Create Toast', options, this.preQueue);
  }

  async dismissAll(): Promise<void> {
    const elements = this.container?.querySelectorAll(this.tag)
    if (elements) {
      const closingQueue = []
      for (let index = 0; index < elements.length; index++) {
        const el = elements[index] as unknown as HTMLNoticeElement
        if (el.close) {
          closingQueue.push(el.close())
        }
      }
      this.queue = [];
      await Promise.all(closingQueue)
    }
  }

  private setupContainer() {
    const containerId = `nest-notices-container`
    this.container = document.getElementById(containerId)

    if (this.container) return

    if (!this.container) {
      this.container = document.createElement('nest-notices')
      this.container.setAttribute('interface', this.tag.replace('nest-', ''))
      this.container.id = containerId
    }

    document.body.appendChild(this.container)
  }
}

export const nestToastController = new NestToastController()
